import { CustomSvgIcon } from "modules/common/components/CustomSvgIcon";

interface IIcon {
  width?: number;
  height?: number;
}

export const PCIcon = ({ width, height }: IIcon) => (
  <CustomSvgIcon
    width={20}
    height={20}
    fill="#FFFFFF"
    viewBox="0 0 20 20"
    style={{ width: width || 15, height: height || 15 }}
  >
    <rect
      fill="transparent"
      x="2"
      y="3"
      width="16"
      height="11"
      stroke="white"
      strokeWidth="2"
    />
    <rect x="7" y="17" width="6" height="2" fill="white" />
    <rect
      x="9"
      y="17"
      width="2"
      height="2"
      transform="rotate(-90 9 17)"
      fill="white"
    />
  </CustomSvgIcon>
);

export const AppleIcon = ({ width, height }: IIcon) => (
  <CustomSvgIcon
    width={18}
    height={22}
    fill="#FFFFFF"
    viewBox="0 0 18 22"
    style={{ width: width || 15, height: height || 15 }}
  >
    <path
      d="M14.9736 6.477C14.8627 6.5632 12.9172 7.65914 12.9172 10.0972C12.9172 12.917 15.3922 13.9145 15.4661 13.9391C15.4538 14.0006 15.0721 15.3059 14.1608 16.6357C13.3482 17.8056 12.4984 18.9753 11.2055 18.9753C9.91265 18.9753 9.58012 18.2242 8.09014 18.2242C6.63712 18.2242 6.11992 19 4.93778 19C3.75565 19 2.9306 17.9163 1.98251 16.5865C0.886571 15.0226 0 12.5968 0 10.2942C0 6.60004 2.40123 4.6421 4.76538 4.6421C6.02144 4.6421 7.06801 5.46715 7.8561 5.46715C8.60723 5.46715 9.77708 4.59286 11.2054 4.59286C11.7473 4.59298 13.693 4.64234 14.9736 6.477ZM10.5283 3.0292C11.1193 2.32731 11.5381 1.35454 11.5381 0.381764C11.5381 0.246323 11.5258 0.110881 11.5011 0C10.5406 0.0369603 9.39544 0.640369 8.70583 1.44074C8.16406 2.05643 7.65914 3.0292 7.65914 4.01437C7.65914 4.16209 7.68382 4.30993 7.6961 4.35917C7.75762 4.37145 7.85622 4.38385 7.9547 4.38385C8.81671 4.38374 9.90024 3.80501 10.5283 3.0292Z"
      fill="white"
    />
  </CustomSvgIcon>
);

export const LinuxIcon = ({ width, height }: IIcon) => (
  <CustomSvgIcon
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    style={{ width: width || 15, height: height || 15 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3872 22.8407C22.6425 22.5379 22.0301 22.0579 22.0732 21.1435C22.1163 20.2292 21.4147 19.6235 21.4147 19.6235C21.4147 19.6235 22.0272 17.6206 21.4579 15.9662C20.8886 14.309 19.0052 11.6575 17.5618 9.65454C16.8176 8.62181 16.7827 7.50781 16.7439 6.26552C16.7073 5.09845 16.6673 3.81817 16.0322 2.3857C14.7153 -0.571551 11.3023 -0.400116 9.46212 0.862788C7.86238 1.95819 8.08359 4.4701 8.22539 6.08023C8.2467 6.32225 8.26622 6.54389 8.27749 6.73729C8.36663 8.21449 8.31775 9.26881 8.1481 9.65168C8.07617 9.81134 7.81628 10.1383 7.48536 10.5546L7.48535 10.5546L7.48535 10.5546C7.02267 11.1366 6.42114 11.8933 6.00025 12.6118L5.95748 12.6848C4.99556 14.3265 4.40706 15.331 4.07093 17.2263C3.93983 17.9655 3.89553 19.1406 3.89553 19.1406C3.89553 19.1406 3.50162 19.2692 3.19396 19.9264C2.8863 20.5778 2.27386 20.8807 1.17837 21.0978C0.0828843 21.315 0.0828842 22.015 0.344537 22.7979C0.560161 23.436 0.424262 23.8445 0.201575 24.5138C0.15107 24.6656 0.0961003 24.8308 0.0397547 25.0151C-0.0918817 25.4418 0.113367 25.7424 0.507979 25.9601L0.5 26L0.653256 26.0328C1.18637 26.2758 1.97609 26.4028 2.75404 26.4923C2.79137 26.4967 2.8288 26.5017 2.86634 26.5071L3.64203 26.6733C4.12617 26.8058 4.61921 26.9851 5.1076 27.1628L5.10762 27.1628C5.8708 27.4404 6.62262 27.7139 7.31139 27.7981C8.71166 27.9724 9.14871 26.8409 9.14871 26.8409C9.14871 26.8409 10.7244 26.4895 12.3892 26.4495C14.054 26.4066 15.6296 26.798 15.6296 26.798C15.6296 26.798 15.9373 27.4952 16.5066 27.7981C17.0759 28.1038 18.3037 28.1467 19.0915 27.3209C19.7416 26.6397 21.2779 25.8136 22.4605 25.1777L22.4605 25.1777C22.7164 25.0401 22.9556 24.9115 23.1658 24.7951C24.3504 24.1437 24.1319 23.1436 23.3872 22.8407ZM13.1396 3.64861C13.8901 3.64861 14.4968 4.38863 14.4968 5.3001C14.4968 5.94869 14.192 6.50585 13.7492 6.77729C13.673 6.74431 13.5929 6.71001 13.5097 6.67439L13.3898 6.623C13.6572 6.49157 13.847 6.15441 13.847 5.75726C13.847 5.24295 13.5278 4.82579 13.131 4.82579C12.74 4.82579 12.4179 5.24295 12.4179 5.75726C12.4179 5.94869 12.4639 6.13156 12.5416 6.28013L12.2923 6.18199L12.2921 6.18192C12.1557 6.12813 12.0304 6.07872 11.9234 6.03727C11.8314 5.8144 11.7796 5.56296 11.7796 5.29724C11.7796 4.38863 12.3863 3.64861 13.1396 3.64861ZM13.0419 7.13159C13.4185 7.26017 13.8355 7.50303 13.7923 7.74304C13.7628 7.90918 13.6607 7.96167 13.4362 8.07702C13.3325 8.1303 13.2027 8.19699 13.0419 8.29449L12.9035 8.37785C12.3551 8.7088 11.4023 9.2838 11.078 9.3231C10.7892 9.3581 10.604 9.23306 10.3407 9.05534C10.2815 9.01541 10.2184 8.97283 10.1493 8.9288C9.77265 8.68594 9.0682 8.11448 9.24647 7.80876C9.24647 7.80876 9.79565 7.3916 10.0372 7.17159C10.2816 6.95159 10.8998 6.42585 11.2736 6.49443C11.5316 6.53944 12.089 6.76006 12.5357 6.93684L12.5358 6.93685C12.7412 7.01816 12.9232 7.09019 13.0419 7.13159ZM9.65476 3.90862C10.2471 3.90862 10.7273 4.60864 10.7273 5.47439C10.7273 5.63439 10.7129 5.78011 10.6812 5.92298C10.5375 5.97155 10.3908 6.05155 10.2471 6.17156C10.1752 6.23156 10.1119 6.28585 10.0487 6.34013C10.1436 6.16584 10.1809 5.91726 10.1378 5.65439C10.0573 5.18295 9.74102 4.83722 9.42761 4.88579C9.11421 4.94008 8.92444 5.36295 9.00494 5.84012C9.08545 6.31442 9.40174 6.66015 9.71227 6.60872C9.72952 6.60586 9.74677 6.60014 9.76402 6.59443C9.61163 6.74015 9.47074 6.86587 9.32698 6.97159C8.89281 6.77158 8.57652 6.17727 8.57652 5.47439C8.58515 4.60864 9.06533 3.90862 9.65476 3.90862ZM16.245 19.8349C16.1184 20.4492 16.1184 22.6665 16.1184 22.6665C16.1184 22.6665 14.7613 24.5351 12.6566 24.8408C10.5547 25.1465 9.50237 24.9265 9.50237 24.9265L8.32062 23.5808C8.32062 23.5808 9.23784 23.4493 9.10845 22.535C9.04128 22.0706 8.31911 21.5163 7.56173 20.9349C6.82796 20.3717 6.06115 19.7831 5.82486 19.2263C5.34469 18.0977 6.35104 15.2205 6.35104 15.2205L7.96984 11.4775C7.96984 11.4775 9.06245 9.3031 8.84393 8.64879C8.84393 8.64879 10.1579 10.2174 11.0752 9.95741C11.4782 9.84225 12.1004 9.48527 12.6977 9.14254L12.6977 9.14254C13.4639 8.70293 14.1891 8.28679 14.3588 8.4345C14.6635 8.69736 17.2916 14.4404 17.5532 16.2691C17.8177 18.0949 17.3778 19.4892 17.3778 19.4892C17.3778 19.4892 16.3743 19.2263 16.245 19.8349Z"
      fill="white"
    />
  </CustomSvgIcon>
);

export const IOSIcon = ({ width, height }: IIcon) => (
  <CustomSvgIcon
    width={20}
    height={20}
    fill="#FFFFFF"
    viewBox="0 0 20 20"
    style={{ width: width || 15, height: height || 15 }}
  >
    <path
      d="M14.8907 -0.000198364H5.10927C2.29194 -0.000198364 0 2.29189 0 5.10956V14.8905C0 17.7079 2.29209 20.0003 5.10927 20.0003H14.8907C17.7081 20.0003 20 17.708 20 14.8905V5.10956C20 2.29223 17.7079 0.000283287 14.8907 0.000283287V-0.000198364ZM5.22301 17.1613H4.25956V12.3894H5.22301V17.1613ZM9.94617 16.5901C9.52732 17.025 8.96745 17.2428 8.26659 17.2428C7.55707 17.2428 6.9927 17.0263 6.57406 16.5933C6.15521 16.1605 5.94588 15.5642 5.94588 14.8046C5.94588 14.3187 6.01854 13.9106 6.16406 13.5806C6.27249 13.3376 6.42064 13.1198 6.60852 12.9265C6.7962 12.7333 7.00177 12.5901 7.22522 12.4969C7.52247 12.3711 7.86526 12.3081 8.25383 12.3081C8.95694 12.3081 9.51962 12.5261 9.94164 12.9622C10.3637 13.3984 10.5747 14.0051 10.5747 14.7818C10.5744 15.5523 10.3648 16.1551 9.94617 16.5901ZM14.7342 16.5397C14.5823 16.7784 14.3675 16.9557 14.0897 17.0719C13.8118 17.1878 13.4658 17.2458 13.0513 17.2458C12.4479 17.2458 11.9847 17.1065 11.6615 16.8277C11.338 16.5489 11.1449 16.1425 11.082 15.6088L12.0195 15.5177C12.076 15.8323 12.1904 16.0634 12.3631 16.2108C12.5355 16.3584 12.7682 16.4322 13.0613 16.4322C13.3715 16.4322 13.6053 16.3665 13.7629 16.2353C13.9201 16.1041 13.9988 15.9505 13.9988 15.7747C13.9988 15.6619 13.9656 15.5657 13.8996 15.4866C13.8333 15.4076 13.7177 15.3385 13.5528 15.2799C13.44 15.2408 13.1827 15.1715 12.7814 15.0716C12.2648 14.9437 11.9024 14.7864 11.6942 14.5998C11.4013 14.3374 11.2548 14.017 11.2548 13.6393C11.2548 13.3963 11.3237 13.1691 11.4615 12.9577C11.5995 12.7459 11.7979 12.5848 12.0573 12.4741C12.3165 12.3634 12.6296 12.3082 12.9963 12.3082C13.5953 12.3082 14.0459 12.4394 14.3488 12.702C14.6513 12.9648 14.8104 13.3154 14.8257 13.7536L13.8622 13.7958C13.821 13.5507 13.7325 13.3745 13.597 13.2668C13.4614 13.1594 13.2579 13.1056 12.9867 13.1056C12.7067 13.1056 12.4875 13.1632 12.3291 13.2782C12.2271 13.352 12.1762 13.4507 12.1762 13.5743C12.1762 13.6873 12.2239 13.7839 12.3195 13.8641C12.4409 13.9663 12.7361 14.0724 13.2048 14.1831C13.6736 14.2938 14.0201 14.4081 14.2449 14.5267C14.4693 14.6449 14.6451 14.8066 14.7722 15.0116C14.899 15.2168 14.9625 15.4702 14.9625 15.7717C14.9619 16.0449 14.8861 16.3007 14.7341 16.5396L14.7342 16.5397ZM18.5403 8.88446C17.8462 9.1817 17.0825 9.3468 16.2809 9.3468C13.1076 9.3468 10.5263 6.76517 10.5263 3.59176C10.5263 2.83876 10.6719 2.11926 10.9362 1.45967H14.8911C16.9034 1.45967 18.5406 3.09707 18.5406 5.10941L18.5403 8.88446Z"
      fill="white"
    />
  </CustomSvgIcon>
);

export const AndroidIcon = ({ width, height }: IIcon) => (
  <CustomSvgIcon
    width="26"
    height="15"
    viewBox="0 0 26 15"
    fill="none"
    style={{ width: width || 15, height: height || 15 }}
  >
    <path
      d="M18.9833 10.9442C18.3863 10.9442 17.9007 10.4582 17.9007 9.86124C17.9007 9.26425 18.3863 8.77864 18.9833 8.77864C19.5803 8.77864 20.0659 9.26425 20.0659 9.86124C20.0659 10.4582 19.5803 10.9442 18.9833 10.9442ZM7.01671 10.9442C6.4197 10.9442 5.93411 10.4582 5.93411 9.86124C5.93411 9.26425 6.4197 8.77864 7.01671 8.77864C7.61369 8.77864 8.09931 9.26425 8.09931 9.86124C8.09931 10.4582 7.61369 10.9442 7.01671 10.9442ZM19.3716 4.42258L21.5354 0.675115C21.6594 0.459718 21.5856 0.184589 21.3706 0.0602004C21.1555 -0.0638368 20.88 0.00995284 20.7557 0.224997L18.5648 4.0199C16.8894 3.2553 15.0078 2.82943 13 2.82943C10.9922 2.82943 9.11058 3.2553 7.43519 4.0199L5.24434 0.224997C5.11995 0.00995284 4.84447 -0.0638368 4.62943 0.0602004C4.41438 0.184589 4.34024 0.459718 4.46463 0.675115L6.62842 4.42258C2.91293 6.44337 0.371755 10.2049 0 14.6488H26C25.6279 10.2049 23.0867 6.44337 19.3716 4.42258Z"
      fill="white"
    />
  </CustomSvgIcon>
);

export const WebIcon = ({ width, height }: IIcon) => (
  <CustomSvgIcon
    width={20}
    height={20}
    fill="#FFFFFF"
    viewBox="0 0 20 20"
    style={{ width: width || 15, height: height || 15 }}
  >
    <circle
      cx="10"
      cy="10"
      r="7"
      stroke="white"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M3 9.5C3 9.5 6.87581 11 10 11C13.1242 11 17 9.5 17 9.5"
      stroke="white"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M10.5 3C10.5 3 13 6.5 13 10C13 13.5 10.5 17 10.5 17"
      stroke="white"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M9.5 17C9.5 17 7 13.5 7 10C7 6.5 9.5 3 9.5 3"
      stroke="white"
      strokeWidth="2"
      fill="transparent"
    />
  </CustomSvgIcon>
);

export const Platform = ({
  platform,
  width,
  height,
}: {
  platform: string;
  width?: number;
  height?: number;
}) => {
  if (platform === "pc") {
    return <PCIcon width={width} height={height} />;
  }

  if (platform === "mac") {
    return <AppleIcon width={width} height={height} />;
  }

  if (platform === "linux") {
    return <LinuxIcon width={width} height={height} />;
  }

  if (platform === "ios") {
    return <IOSIcon width={width} height={height} />;
  }

  if (platform === "android") {
    return <AndroidIcon width={width} height={height} />;
  }

  if (platform === "web") {
    return <WebIcon width={width} height={height} />;
  }

  return <WebIcon width={width} height={height} />;
};
